import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Link as ScrollLink } from "react-scroll";

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  // Toggle function
  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };
  const navigate = useNavigate();

  const goToSection = (sectionId) => {
    navigate('/', { state: { scrollTo: sectionId } });
  };
  return (
    <>
      <style>
        {`
          .navbar-nav .nav-link {
            transition: color 0.3s ease-in-out;
            font-size: 1.1rem;
            font-weight: 600;
            margin-right: 40px;
          }
          .navbar-nav .nav-link:last-child {
            margin-right: 0;
          }
          .navbar-nav .nav-link:hover {
            color: yellowgreen !important;
            font-weight: 700 !important;
          }
          .dropdown-menu .dropdown-item:hover {
            background-color: yellowgreen !important;
            color: white !important;
          }
          .navbar-collapse {
            display: ${isMenuOpen ? "block" : "none"} !important;
          }
          .custom-toggler {
            background: none;
            border: none;
            outline: none;
            display: none;
          }
          .custom-toggler img {
            width: 30px;
            height: 30px;
          }
          @media (max-width: 991px) {
            .custom-toggler {
              display: block;
            }
          }
        `}
      </style>

      <nav className="navbar navbar-expand-lg bg-white navbar-light shadow sticky-top p-0">
        <a href="/" className="navbar-brand d-flex align-items-center px-4 px-lg-5">
          <img src="assets/img/codermonk_favicon.png" width={70} height={63} alt="Logo" />
        </a>

        <button
          type="button"
          className="custom-toggler me-4 d-lg-none"
          onClick={toggleMenu}
        >
          <img src="assets/img/list.png" alt="Toggle Menu" />
        </button>

        <div className={`collapse navbar-collapse ${isMenuOpen ? "show" : ""}`} id="navbarCollapse">
          <div className="navbar-nav ms-auto p-4 p-lg-0">
            <Link to="/" smooth={true} duration={500} className="nav-item nav-link" onClick={toggleMenu}>
              Home
            </Link>
            <ScrollLink to="features" smooth={true} duration={500} className="nav-item nav-link" onClick={toggleMenu}>
             <span style={{cursor:"pointer"}}  onClick={() => goToSection('features')}>Features</span> 
            </ScrollLink>
            <ScrollLink to="courses" smooth={true} duration={500} className="nav-item nav-link" onClick={toggleMenu}>
            <span style={{cursor:"pointer"}} onClick={() => goToSection('courses')}>Courses</span>
            </ScrollLink>
            <ScrollLink to="testimonials" smooth={true} duration={500} className="nav-item nav-link me-5" onClick={toggleMenu}>
            <span style={{cursor:"pointer"}} onClick={() => goToSection('testimonials')}>Testimonials</span>
            </ScrollLink>
            <Link to="/blogs" smooth={true} duration={500} className="nav-item nav-link me-5" onClick={toggleMenu}>
            Blog
            </Link>
          
          </div>

          <ScrollLink
            to="contact"
            smooth={true}
            duration={500}
            className="btn py-4 px-lg-5 d-none d-lg-block text-white"
            style={{ backgroundColor: "yellowgreen", borderRadius: 0 }}
          >
            <span onClick={() => goToSection('contact')}>Join Now</span>
            <i className="fa fa-arrow-right ms-3" />
          </ScrollLink>
        </div>
      </nav>
    </>
  );
};

export default Header;